module.exports = __webpack_public_path__ + "img/player2.5e8374ec.png";